import { useEffect, useState } from 'react';

var getWindowScrollY = function getWindowScrollY() {
  return typeof window === 'undefined' ? 0 : window.scrollY;
};

var isWindowScrolled = function isWindowScrolled() {
  return getWindowScrollY() > 0;
};
/**
 * Returns true if the window is scrolled
 * @param {boolean} transparent
 * @returns boolean - is scrolled
 */


export function useIsScrolled(transparent) {
  var _useState = useState(isWindowScrolled),
      isScrolled = _useState[0],
      setIsScrolled = _useState[1];

  useEffect(function () {
    if (!transparent) return;
    if (typeof window === 'undefined') return;

    var listener = function listener() {
      return setIsScrolled(isWindowScrolled());
    };

    window.addEventListener('scroll', listener, {
      passive: true
    });
    return function () {
      window.removeEventListener('scroll', listener, {
        passive: true
      });
    };
  }, [transparent]);
  return isScrolled;
}